const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://yg7ibxmth5.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://v1olgq0vqe.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.teck.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.2',
    HOSTNAME: 'https://targets.staging.teck.forwoodsafety.com'
  }
};

export default config;